import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Text";
import css from "./styles.module.scss";
import { appStore } from "store";
import { getCity } from "store/selectors";
export const SummerChallengeSection = ({ passedRef, src }) => {
  const { city } = appStore.useState(getCity);

  const { t } = useTranslation();
  return (
    <div ref={passedRef} className={css.SummerChallengeSection}>
      <img src={src} className={css.image} />
      <Text type="white" alignCenter size="body">
        {t("summerChallenge.mainText")}
      </Text>
      <Text type="white" alignCenter size="bodyLead" bold>
        {t("summerChallenge.howToParticipateTitle")}
      </Text>
      <Text type="white" alignCenter size="body">
        {t("summerChallenge.howToParticipateDescription", { city })}
      </Text>
      <Text type="white" alignCenter size="body">
        {t("summerChallenge.aboutTOS")}
      </Text>
    </div>
  );
};
